import React from 'react';

import Issue from './Issue';

const OverScheduled = ({ issue }) => <Issue issue={issue} />;

export default OverScheduled;
